module.exports = __webpack_public_path__ + "img/csc_logo.f07ffacf.webp";